export const PATH = {
  HOME: '/',
  TRAFFIC_FINE_FAQ: '/traffic-fine-faq',
  TRAFFIC_FINE_LOOKUP: '/traffic-fine-lookup',
  TRAFFIC_FINE_CHECK_RESULT: '/traffic-fine-check-result',
  TRAFFIC_FINE_SERVICES: '/traffic-fine-services',
  TRAFFIC_FINE_VEHICLES: '/traffic-fine-vehicles',
  TRAFFIC_FINE_PACKAGE_INFO: '/traffic-fine-package-info',
  TRAFFIC_FINE_REGISTRATION_MANAGEMENT: '/traffic-fine-registration-management',
  TRAFFIC_FINE_REGISTRATION_MANAGEMENT_FIRST_TIME: '/traffic-fine-registration-management/first-time',
  AUTO_TRAFFIC_FINE_NOTIFICATION_PAYMENT: '/auto-traffic-fine-notification/payment',
  AUTO_TRAFFIC_FINE_NOTIFICATION_SUCCESS: '/auto-traffic-fine-notification/success/:id',
  TRAFFIC_FINE_CONSENT: '/traffic-fine-consent'
}
